export default __webpack_public_path__ + "f2bcdc45a2454b6c03aed232ca0aa331.png";